const BreadCrumb = ({ breadCrumbArray = [] }: any) => {
    return (
      <div className="flex items-center mt-4 gap-1">
        {breadCrumbArray.map(
          (item: { link: string; label: string }, index: number) => (
            <div className="font-[400] flex items-center gap-1">
              <a
                className={`text-[14px] text-[${
                  index + 1 === breadCrumbArray.length ? "#181819B2" : "#18181966"
                }] ${
                  index + 1 === breadCrumbArray.length ? "cursor-not-allowed font-semibold" : ""
                }`}
                href={item.link}
              >
                <p>{item.label}</p>
              </a>
              {index + 1 !== breadCrumbArray.length && (
                <p className="text-[16px]">/</p>
              )}
            </div>
          )
        )}
      </div>
    );
  };
  
  export default BreadCrumb;
  